module.exports = __webpack_public_path__ + "img/icon-import.7628b624.svg";